<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="headline">
        Attenzione
      </v-card-title>
      <v-card-text>
        Stai aggiungendo un prodotto di un altro fornitore.
       <!-- Tabella ACQUISTI -->
        <v-col cols="12" class="mt-5 pa-0">
          <h3>LISTA ULTIMI FORNITORI</h3>
          <v-simple-table dense class="mt-1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">FORNITORE</th>
                  <th class="text-right">QUANTITA'</th>
                  <th class="text-right">PREZZO</th>
                  <th class="text-right">ULTIMO ACQUISTO</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in fornitori" :key="item._id">
                  <td class="text-left">{{ item.fornitore.descrizione }}</td>
                  <td class="text-right">{{ item.quantita }}</td>
                  <td class="text-right">{{ item.prezzo | euro }}</td>
                  <td class="text-right">{{ item.data | date }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          CHIUDI
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import movimenti from '@/services/movimentiService'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    prodotto: Object
  },
  data () {
    return {
      fornitori: []
    }
  },
  watch: {
    async value(value) {
      if (value) {
        await this.elaboraFornitori()
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('chiudiPopup', val);
      }
    }
  },
  methods: {
    async elaboraFornitori() {
      if (!this.prodotto) return
      const r = this.prodotto
      const mm = await movimenti.getMovimentiProdottoTipoCliente(r.prodotto.codice, null, 'acquisto')
      const fornitori = []
      for (let m of _.sortBy(mm.rows, 'data').reverse()) {
        if(m.anagrafica.fornitore){
          const riga = {
            fornitore: m.anagrafica.fornitore,
            quantita: m.quantita,
            prezzo: +(m.valore / m.quantita).toFixed(2),
            data: m.data
          }
          fornitori.push(riga)
        }
      }
      this.fornitori = fornitori
    }
  }
};
</script>